<div class="row mb-3" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <i class="fas fa-fw fa-object-group me-2"></i>Firebase Auth Token (Devs)
  </div>
</div>
<div class="tokenux-container">
  <h3 class="tokenux-header">Firebase Bearer Token</h3>
  <button class="btn btn-primary mb-3" (click)="generateToken()">Generate Token</button>
  <div *ngIf="showToken">
    <textarea class="form-control mb-2" rows="6" readonly>{{ token }}</textarea>
    <button class="btn btn-secondary" (click)="copyToken()">Copy to Clipboard</button>
  </div>
</div>
